import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import revelatorGenres from "shared/helpers/revelator-genres";
import { fetchFilterGenres } from "shared/service/RadarService";

export const getGeneros = createAsyncThunk("generos/get-genero", async () => {
  return await fetchFilterGenres();
});

export type GenresState = {
  genres: {
    genres: any[];
    revelatorGenres: any[];
    loading: boolean;
    genreOptions: { label: string; value: string }[];
  };
};

export const genresSlice = createSlice({
  name: "genres",
  initialState: {
    genres: [],
    revelatorGenres: revelatorGenres,
    loading: true,
    genreOptions: [],
  },
  reducers: {
    setGenreOptionsI18n: (state, action) => {
      state.genreOptions = state.genres.map((genre: any) => ({
        label: genre[`${action.payload}`],
        value: genre.code,
      })) as any;
    },
  },
  extraReducers: {
    [getGeneros.fulfilled.type]: (state, action) => {
      if (action.payload) {
        state.genres = action.payload;
        state.loading = false;
      }
    },
  },
});

export const { setGenreOptionsI18n } = genresSlice.actions;

export default genresSlice.reducer;
